import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
const ShareDataContext = createContext(null);
export function useShareData() {
    const context = useContext(ShareDataContext);
    if (!context) {
        throw new Error('useShareData must be used within an ShareDataProvider');
    }
    return context;
}
export function ShareDataProvider({ children, }) {
    const [data, setData] = useState(null);
    const state = useMemo(() => {
        return {
            data,
            setData: (newData) => {
                setData(newData);
            },
        };
    }, [data]);
    return (_jsx(ShareDataContext.Provider, { value: state, children: children }));
}
